import React from "react";
import "./LegalPages.css";

const GDPR = () => {
  return (
    <section className="legal-page">
      <h1>GDPR Compliance</h1>
      <p>
        <b>Mailsnappy</b> is committed to complying with the General Data Protection Regulation
        (GDPR) and protecting the privacy and rights of our users in the European Union.
      </p>

      <h2>1. Lawful Data Processing</h2>
      <p>
        We only process personal data when we have a lawful basis such as user consent, contractual
        necessity, or legitimate interest.
      </p>

      <h2>2. Data Access and Control</h2>
      <p>
        Users can request access, correction, or deletion of their personal data at any time by
        contacting <a href="mailto:support@mailsnappy.com">support@mailsnappy.com</a>.
      </p>

      <h2>3. Data Retention</h2>
      <p>
        We retain personal data only as long as necessary to fulfill service obligations or comply
        with legal requirements.
      </p>

      <h2>4. Third-Party Processors</h2>
      <p>
        We may work with trusted third-party providers for hosting, analytics, or payments, all of
        whom comply with GDPR standards.
      </p>

      <h2>5. Data Transfers</h2>
      <p>
        Where data is transferred outside the EU, we ensure equivalent protection standards through
        approved contractual clauses.
      </p>

      <h2>6. Contact</h2>
      <p>
        For GDPR inquiries, please reach out to our Data Protection Officer at{" "}
        <a href="mailto:support@mailsnappy.com">support@mailsnappy.com</a>.
      </p>
    </section>
  );
};

export default GDPR;
